import { formatKey } from "../../_helper";

const PackageDetailsSection = ({
  title,
  data,
  columns = 2,

  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  const gridColumnsClass =
    columns === 1
      ? "tw-grid-cols-1"
      : columns === 2
      ? "lg:tw-grid-cols-2"
      : columns === 3
      ? "lg:tw-grid-cols-3"
      : `lg:tw-grid-cols-${columns}`;

  return (
    <section className={className}>
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div
        className={`tw-grid ${gridColumnsClass}  tw-grid-cols-1  tw-gap-2 tw-text-gray-700`}
      >
        {Object.entries(data).map(([key, value]) => (
          <div key={key}>
            <p>
              <strong className="tw-text-primary">{formatKey(key)}:</strong>{" "}
              {["Is Active", "Pv Active", "Pv Upliner Active"].includes(
                formatKey(key)
              )
                ? value == 1
                  ? "Yes"
                  : "No"
                : value
                ? value
                : "-"}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PackageDetailsSection;
